jQuery(document).ready(function() {
    if ($.cookie('sg-color-theme')) {
        $('#theme-css').attr('href', $.cookie('sg-color-theme'));
    }
    if ($('.sg-theme-chooser').length) {
        sgThemeChooser();
    }
    if ($('.sg-page-index').length) { // index page

        if ($.cookie('sg-toolbar-visible') === '1') {
            $('.toolbar-toggle-wrapper').find('input').attr('checked', 'checked');
        }
        $('.toolbar-toggle-wrapper').find('input').on('change', function() {
            if ($(this).is(':checked')) {
                $.cookie('sg-toolbar-visible', '1');
            } else {
                $.cookie('sg-toolbar-visible', '0');
            }
        });
    } else { // example pages
        $('body').sgNavigationToolbar();
    }
});

window.sgThemeChooser = function() {
    var $css = $('#theme-css');
    var css_href = $css.attr('href');
    $.ajax({
        'url': '../dummy/json/color-themes.json',
        'dataType': 'json',
        'success': function(data) {
            var $select = $('.sg-theme-chooser').find('select');
            for (var i = 0; i < data.length; i++) {
                if (data[i].href == css_href) {
                    $select.append('<option selected value="' + data[i].href + '">Farbschema ' + data[i].name + '</option>');
                } else {
                    $select.append('<option value="' + data[i].href + '">' + data[i].name + '</option>');
                }
            }
            $select.on('change', function() {
                $.cookie('sg-color-theme', $(this).val());
                $css.attr('href', $(this).val());
            });
        }
    });
};
